import { render, staticRenderFns } from "./conversation-summary-dialog.vue?vue&type=template&id=888484ec&scoped=true&"
import script from "./conversation-summary-dialog.vue?vue&type=script&lang=js&"
export * from "./conversation-summary-dialog.vue?vue&type=script&lang=js&"
import style0 from "./conversation-summary-dialog.vue?vue&type=style&index=0&id=888484ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888484ec",
  null
  
)

export default component.exports